import { render, staticRenderFns } from "./retailuser.vue?vue&type=template&id=1a87a7cc&scoped=true"
import script from "./retailuser.vue?vue&type=script&lang=js"
export * from "./retailuser.vue?vue&type=script&lang=js"
import style0 from "./retailuser.vue?vue&type=style&index=0&id=1a87a7cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a87a7cc",
  null
  
)

export default component.exports